import { IonToast, useIonViewDidEnter, useIonViewWillLeave } from '@ionic/react';
import React, { useContext, useEffect, useRef, useState } from 'react';
import NetworkStatusContext from '../NetworkStatusContext/NetworkStatusContext';

interface INetworkNotificationProps {
    noInternetMessage: string;
    recheckNetwork?: number;
}

const NetworkNotification: React.FC<INetworkNotificationProps> = (props) => {
    const NetworkService = useContext(NetworkStatusContext);
    const [showNoNetworkConnectionMessage, setShowNoNetworkConnectionMessage] = useState(false);
    const [toastMessage, setToastMessage] = useState(props.noInternetMessage);
    const [toastColor, setToastColor] = useState('danger');
    const networkStatusConnected = useRef<boolean>(true);
    const networkStatusSub = useRef<number | undefined>(undefined);

    useIonViewDidEnter(() => {
      checkNetworkStatus();
      networkStatusSub.current = NetworkService?.setCallback(connectionStatusUpdate);
      return () => {}
    }, []);

    useIonViewWillLeave(() => {
        if(networkStatusSub.current !== undefined) {
          NetworkService?.clearCallback(networkStatusSub.current);
        }
      return () => {}
    }, []);

    useEffect(() => {
      checkNetworkStatus();
      return () => {}
    }, [props.recheckNetwork]);

    const checkNetworkStatus = () => {
        console.log("Network Status Checked: ", NetworkService?.networkConnected)
        if(NetworkService?.isListening && !NetworkService?.networkConnected) {
          setToastMessage(props.noInternetMessage);
          setToastColor('danger');
          setShowNoNetworkConnectionMessage(true);
        }
    }

    const connectionStatusUpdate = (connected: boolean) => {
      if(!connected) {
        // if network not connected and previous status was connected
        if (networkStatusConnected.current) {
          setToastMessage("INTERNET CONNECTION LOST");
          setToastColor('danger');
          setShowNoNetworkConnectionMessage(true);
          networkStatusConnected.current = false;
        }
      } else {
        // if network connected and previous status was not connected
        if (!networkStatusConnected.current) {
          setToastMessage("INTERNET CONNECTION ACQUIRED");
          setToastColor('success');
          setShowNoNetworkConnectionMessage(true);
          networkStatusConnected.current = true;
        }
      }
    }

    return <IonToast color={toastColor}
        isOpen={showNoNetworkConnectionMessage}
        onDidDismiss={() => setShowNoNetworkConnectionMessage(false)}
        message={toastMessage}
        duration={3000} />
};

export default NetworkNotification;